<template>
    <div class="timeout-content-shift">
        <v-card
            v-for="row in rows"
            :key="row.key"
            color="#232323"
            class="timeout-row rounded-lg px-10 py-5 white--text"
            :style="`box-shadow: inset 30px 0 0 0 ${row.color};`"
        >
            <div class="media-row">
                <span class="timeout-logo ml-5">
                    <img :src="`${assetsUrl}/${row.team?.logo}`" alt="">
                </span>
                <span class="timeout-team-name">{{ row.team.name }}</span>
                <span
                    v-for="period in periods"
                    :key="`${row.key}-period-${period}`"
                    class="timeout-period"
                    :style="{
                        color: ((Number(row.periodScores[period]) || 0) > (Number(row.opponentPeriodScores[period]) || 0)) ? '#00f3b3' : ''
                    }"
                >
                    {{ row.periodScores[period] ?? '-' }}
                </span>
                <span
                    class="timeout-total"
                    :class="(Number(row.score) || 0) > (Number(row.opponentScore) || 0) ? 'custom-teal-text' : 'white--text'"
                >
                    {{ row.score ?? 0 }}
                </span>
            </div>
        </v-card>
    </div>
</template>

<script>
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'

    export default {
        name: 'TimeOut',
        props: {
            match: {
                type: Object,
                default: () => ({ team1: {}, team2: {} })
            },
            periodScoresTeam1: {
                type: Object,
                default: () => ({})
            },
            periodScoresTeam2: {
                type: Object,
                default: () => ({})
            },
            periods: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            rows() {
                // team colours that show on the black rows and differ from each other
                const colors = getMatchColors(this.match.team1, this.match.team2, BACKGROUNDS.dark)
                return [
                    {
                        key: 'team1',
                        team: this.match.team1 || {},
                        color: colors.team1,
                        periodScores: this.periodScoresTeam1,
                        opponentPeriodScores: this.periodScoresTeam2,
                        score: this.match.team1Score,
                        opponentScore: this.match.team2Score
                    },
                    {
                        key: 'team2',
                        team: this.match.team2 || {},
                        color: colors.team2,
                        periodScores: this.periodScoresTeam2,
                        opponentPeriodScores: this.periodScoresTeam1,
                        score: this.match.team2Score,
                        opponentScore: this.match.team1Score
                    }
                ]
            }
        }
    }
</script>

<style scoped>
/* Both rows stretch to the wider one, so the period columns line up */
.timeout-content-shift {
    display: inline-flex;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 20px;

    /* Right of the match info header (which ends ~605px from the left), clear of the right edge */
    transform: translateX(calc(2.5vw + 170px));
}

@media (max-width: 960px) {
    .timeout-content-shift {
        transform: translateX(3%);
    }
}

.timeout-row {
    min-width: 1000px;
}

.media-row {
    display: flex;
    align-items: center;        /* vertical center */
    justify-content: flex-start;/* horizontal start (left) */
    gap: 12px;                  /* space between image and text */
}

/* the logo on a white disc, as everywhere on the site */
.timeout-logo {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 140px;
    padding: 10px;
    border-radius: 50%;
    background: #fff;
    overflow: hidden;
}

.timeout-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* the team name on one line: the card grows with it, a very long one ends in "…" so the score stays on screen */
.timeout-team-name {
    flex: 1 1 auto;
    min-width: 300px;
    max-width: 440px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.timeout-period {
    flex: 0 0 90px;
    text-align: center;
    font-size: 55px;
    font-weight: bold;
}

.timeout-total {
    flex: 0 0 150px;
    text-align: right;
    font-size: 75px;
    font-weight: bold;
}
</style>
